import { getSession } from "next-auth/react";

/** Dedupe concurrent getSession() calls within a short window (bundle fetches). */
const SESSION_CACHE_MS = 5000;
let sessionCache: {
  promise: ReturnType<typeof getSession>;
  expiresAt: number;
} | null = null;

export function clearSessionCache(): void {
  sessionCache = null;
}

export async function getSessionOnce() {
  const now = Date.now();
  if (sessionCache && now < sessionCache.expiresAt) {
    return sessionCache.promise;
  }
  const promise = getSession();
  sessionCache = { promise, expiresAt: now + SESSION_CACHE_MS };
  return promise;
}
